import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { Button, Divider, Typography } from '../../../../designComponents';
import { btnData, routes } from '../../data';
import { SidebarContainer } from '../style';

const Sidebar = ({
  Open,
  setOpen,
}: {
  Open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const handleBtnClick = (id: number) => {
    if (id === 0) {
      navigate('/login');
      setOpen(false);
    } else if (id === 1) {
      navigate('/register');
      setOpen(false);
    }
  };
  const theme = useTheme();
  return (
    <SidebarContainer $Open={Open}>
      <div className="main-menu">
        <div>
          {routes.map((route, idx) => (
            <div
              // to={route.url}
              key={idx}
              style={{
                textDecoration: 'none',
              }}
              role="button"
              onClick={() => {
                navigate(route.url);
                setOpen(false);
              }}
            >
              <Typography
                variant="title"
                style={{
                  color: route.url === pathname ? theme.colors.primary : '',
                }}
              >
                {route.label}
              </Typography>

              <Divider style={{ opacity: '0.3' }} />
            </div>
          ))}
        </div>
        <div className="btn">
          {btnData.map((data, idx) => (
            <Button
              key={idx}
              outline={idx === 0}
              color={idx === 1 ? '#fff' : theme.colors.primary}
              style={{
                borderRadius: '30px',
                height: '33px',
              }}
              onClick={() => handleBtnClick(idx)}
            >
              {data.label}
            </Button>
          ))}
        </div>
      </div>
    </SidebarContainer>
  );
};

export default Sidebar;
